<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Menu_Déconnexion_">
                <rect width="50" height="50" />
            </clipPath>
        </defs>
        <g id="Menu_Déconnexion_" data-name="Menu Déconnexion " clip-path="url(#clip-Menu_Déconnexion_)">
            <g id="noun_padlock_512757" transform="translate(720 -672.099)">
                <path id="Tracé_2723" data-name="Tracé 2723" d="M36.048,22.429h-1.1V20.682a6.339,6.339,0,0,0-12.678,0v1.747H21.258c-.563,0-.958.7-.958,1.268V34.318c0,.563.394.789.958.789H36.076c.563,0,.873-.225.873-.789V23.7C36.922,23.133,36.584,22.429,36.048,22.429Zm-6.029,9.015H27.259l.451-2.592a1.471,1.471,0,0,1-.648-1.211,1.578,1.578,0,0,1,3.155,0,1.384,1.384,0,0,1-.648,1.183Zm-6.057-9.015V20.682a4.649,4.649,0,0,1,9.3,0v1.747Z" transform="translate(-724 671.492)" :fill="color" />
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconLogout',
    mixins: [Colorable],
};
</script>
